module.exports = __webpack_public_path__ + "static/image 2-41bb57330638327a67a181eac8110340.png";